import ajax from "./ajax";

class AppApi {
    constructor() { }

    async loadPTOByPeopleAndDateRangeAsync(request) {
        return await ajax.api().post("get-pto-by-people-and-date-range", request);
    }

    async loadTimeOffItemByPeopleAndDateRangeAsync(request) {
        return await ajax.api().post("get-timeoff-item-by-people-and-date-range", request);
    }
}

const appApi = new AppApi();
export default appApi;